import {createContext, ReactNode, useState} from 'react';
import {InnovEnergyUser} from '../interfaces/UserTypes';

// Define the shape of the context
interface UserContextType {
  currentUser?: InnovEnergyUser;
  setUser: (user: InnovEnergyUser) => void;
  removeUser: () => void;
}

// Create the context.
export const UserContext = createContext<UserContextType | undefined>(
  undefined
);

// Create a UserContextProvider component
export const UserContextProvider = ({ children }: { children: ReactNode }) => {
  //Initialize context state with a "null" user
  const [currentUser, setUser] = useState<InnovEnergyUser>(
    JSON.parse(localStorage.getItem('currentUser'))
  );

  const saveUser = (new_user: InnovEnergyUser) => {
    setUser(new_user);
    localStorage.setItem('currentUser', JSON.stringify(new_user));
  };

  const deleteUser = () => {
    localStorage.removeItem('currentUser');
  };

  return (
    <UserContext.Provider
      value={{
        currentUser,
        setUser: saveUser,
        removeUser: deleteUser
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
